"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stylesResetSelector = exports.stylesResetAttribute = exports.isolateCss = void 0;
// Number of selectors to chain together for resetting styles.
// This is used to unset external styles that would typically
// affect our component styles.
var stylesResetSpecificity = 4;
// Number of selectors to chain together for applying component
// styles. This *must be* greater than `stylesResetSpecificity`, and
// it should only need to be greater by 1.
var componentSpecificity = stylesResetSpecificity + 1;
// Selector for component styles. Repeats `[class]` which will
// increase specificity, concatenated onto `&`, which `emotion`
// will transform into a CSS class name.
var componentSelector = '&' + '[class]'.repeat(componentSpecificity);
// type CssPropertiesBuilder =
//   | React.CSSProperties
//   | (() => React.CSSProperties)
//   | (React.CSSProperties | (() => React.CSSProperties))[];
// Returns an object with a selector specific enough to
// override (essentially) any external styles that may
// conflict with the component's own styles. This selector
// is one level more specific than an `all: unset` selector,
// which resets all external styles, thereby allowing this
// more specific selector to define component-specific styles.
exports.isolateCss = function (styles) {
    var _a;
    return Array.isArray(styles)
        ? styles.map(exports.isolateCss)
        : (_a = {},
            _a[componentSelector] = styles,
            _a);
};
exports.stylesResetAttribute = 'data-css-reset';
// Selector for component reset styles. Repeats this attribute
// selector, which is a substring of the CSS class that `emotion`
// applies to all components.
exports.stylesResetSelector = ("[" + exports.stylesResetAttribute + "]").repeat(stylesResetSpecificity);
